import { render, staticRenderFns } from "./ConfirmedPopup.vue?vue&type=template&id=7856d584&scoped=true"
import script from "./ConfirmedPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmedPopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedPopup.vue?vue&type=style&index=0&id=7856d584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7856d584",
  null
  
)

export default component.exports